import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/base/Breadcrumb';
import ScrollToTop from '@/components/base/ScrollToTop';

export default function About() {
  useEffect(() => {
    document.title = '关于我们 - 黑料天天动漫 | 品牌介绍与联系方式';
  }, []);

  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '黑料天天动漫',
    url: 'https://heimanime.com',
    description: '黑料天天动漫是领先的动漫圈内幕资讯平台，专注为动漫爱好者提供最新、最劲爆的动漫黑料爆料内容。',
    email: 'heimanime@163.com',
    telephone: '010-8888-6666',
    address: {
      '@type': 'PostalAddress',
      streetAddress: '朝阳区动漫产业园A座',
      addressLocality: '北京',
      addressRegion: '北京',
      addressCountry: 'CN',
    },
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '黑料天天动漫的内容来源是什么？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '我们的内容来源于行业内部人士投稿、公开报道整理以及编辑团队的独家调查。所有内容均经过编辑团队审核，确保信息的真实性和可靠性。',
        },
      },
      {
        '@type': 'Question',
        name: '如何向黑料天天动漫投稿爆料？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '您可以通过页面下方的联系我们表单提交爆料信息，也可以直接发送邮件至heimanime@163.com。我们承诺对所有爆料人信息严格保密。',
        },
      },
      {
        '@type': 'Question',
        name: '黑料天天动漫的文章是否收费？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '目前黑料天天动漫的所有内容均免费开放阅读。我们通过广告合作和品牌赞助维持运营，不会对读者收取任何费用。',
        },
      },
      {
        '@type': 'Question',
        name: '如何与黑料天天动漫进行广告合作？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '欢迎品牌方和广告主通过页面下方的联系我们表单或发送邮件至heimanime@163.com咨询合作事宜。我们的商务团队会在24小时内回复。',
        },
      },
    ],
  };

  return (
    <div className="min-h-screen bg-background-50">
      <script type="application/ld+json">{JSON.stringify(organizationSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
      <Navbar />

      <main>
        {/* Hero */}
        <section className="pt-20 pb-12 bg-background-100">
          <div className="container-custom">
            <Breadcrumb
              items={[
                { label: '首页', href: '/' },
                { label: '关于我们' },
              ]}
            />
            <div className="mt-6 text-center max-w-2xl mx-auto">
              <h1 className="text-3xl md:text-5xl font-heading font-bold text-foreground-900 mb-4">
                关于黑料天天动漫
              </h1>
              <p className="text-base md:text-lg text-foreground-600 leading-relaxed">
                我们是一个专注于动漫圈内幕爆料的独立媒体平台，致力于为每一位动漫爱好者提供最新、最真实、最劲爆的行业资讯。
              </p>
            </div>
          </div>
        </section>

        {/* Brand Introduction */}
        <section className="py-12 md:py-16">
          <div className="container-custom">
            <div className="max-w-3xl mx-auto">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-6 text-center">
                品牌介绍
              </h2>
              <div className="space-y-5 text-foreground-700 leading-relaxed">
                <p>
                  <strong className="text-foreground-900">黑料天天动漫</strong>成立于2024年，是国内领先的动漫圈内幕资讯平台。我们汇聚了一支由资深动漫媒体人、业内记者和狂热动漫迷组成的编辑团队，每天追踪动漫行业的最新动态和幕后故事。
                </p>
                <p>
                  我们坚信，动漫不仅仅是一种娱乐形式，更是一个充满故事和温度的产业生态。从声优的日常动态到制作公司的内部运作，从IP改编的争议到行业政策的变迁，<strong className="text-foreground-900">黑料天天动漫</strong>致力于为你呈现一个立体、真实、有深度的动漫世界。
                </p>
                <p>
                  我们的内容涵盖<strong className="text-foreground-900">声优黑料、制作公司内幕、IP改编争议、八卦热点、幕后资讯</strong>等多个板块，每天更新不断，让你第一时间掌握动漫圈的最新动态。
                </p>
                <p>
                  我们坚持<strong className="text-foreground-900">真实、客观、深度</strong>的报道原则，所有爆料内容均经过编辑团队的多重核实，确保为读者提供可靠的资讯。同时，我们也极度重视信息来源的保护，对所有爆料人的身份信息严格保密。
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Stats */}
        <section className="py-10 bg-accent-500">
          <div className="container-custom">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center">
              <div>
                <div className="text-3xl md:text-4xl font-heading font-bold text-background-50">1000+</div>
                <div className="text-sm text-background-50/80 mt-1">原创文章</div>
              </div>
              <div>
                <div className="text-3xl md:text-4xl font-heading font-bold text-background-50">500万+</div>
                <div className="text-sm text-background-50/80 mt-1">月阅读量</div>
              </div>
              <div>
                <div className="text-3xl md:text-4xl font-heading font-bold text-background-50">50万+</div>
                <div className="text-sm text-background-50/80 mt-1">活跃粉丝</div>
              </div>
              <div>
                <div className="text-3xl md:text-4xl font-heading font-bold text-background-50">365天</div>
                <div className="text-sm text-background-50/80 mt-1">每日更新</div>
              </div>
            </div>
          </div>
        </section>

        {/* Reputation / Testimonials */}
        <section className="py-12 md:py-16">
          <div className="container-custom">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-2 text-center">
              用户口碑
            </h2>
            <p className="text-sm text-foreground-500 text-center mb-10">来自动漫圈的真实声音</p>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl mx-auto">
              <div className="bg-background-50 rounded-xl border border-background-200/70 p-6">
                <div className="flex items-center gap-1 mb-3">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-accent-500 text-sm"></i>
                  ))}
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                  "黑料天天动漫是我每天必刷的网站！声优圈的八卦太精彩了，很多消息比日本那边的论坛还快，小编真的牛。"
                </p>
                <div className="flex items-center gap-3">
                  <div className="w-9 h-9 rounded-full bg-secondary-200 flex items-center justify-center">
                    <i className="ri-user-line text-secondary-600"></i>
                  </div>
                  <div>
                    <div className="text-sm font-medium text-foreground-900">动漫老司机</div>
                    <div className="text-xs text-foreground-500">资深二次元</div>
                  </div>
                </div>
              </div>

              <div className="bg-background-50 rounded-xl border border-background-200/70 p-6">
                <div className="flex items-center gap-1 mb-3">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-accent-500 text-sm"></i>
                  ))}
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                  "作为业内人士，有时候我自己都是先在黑料天天动漫上看到行业新闻的。信息量和速度确实一流，推荐！"
                </p>
                <div className="flex items-center gap-3">
                  <div className="w-9 h-9 rounded-full bg-secondary-200 flex items-center justify-center">
                    <i className="ri-user-line text-secondary-600"></i>
                  </div>
                  <div>
                    <div className="text-sm font-medium text-foreground-900">动画人小张</div>
                    <div className="text-xs text-foreground-500">动画制作从业者</div>
                  </div>
                </div>
              </div>

              <div className="bg-background-50 rounded-xl border border-background-200/70 p-6">
                <div className="flex items-center gap-1 mb-3">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-accent-500 text-sm"></i>
                  ))}
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                  "关注快一年了，内容质量一直很高。尤其是制作公司内幕的爆料，每次看都涨知识。希望继续保持！"
                </p>
                <div className="flex items-center gap-3">
                  <div className="w-9 h-9 rounded-full bg-secondary-200 flex items-center justify-center">
                    <i className="ri-user-line text-secondary-600"></i>
                  </div>
                  <div>
                    <div className="text-sm font-medium text-foreground-900">樱花飘落</div>
                    <div className="text-xs text-foreground-500">忠实读者</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Contact */}
        <section className="py-12 md:py-16 bg-background-100">
          <div className="container-custom">
            <div className="max-w-4xl mx-auto">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-2 text-center">
                联系我们
              </h2>
              <p className="text-sm text-foreground-500 text-center mb-10">
                有料你就爆！欢迎投稿、合作、建议
              </p>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                {/* Contact Info */}
                <div>
                  <h3 className="text-lg font-heading font-bold text-foreground-900 mb-5">联系方式</h3>
                  <div className="space-y-4">
                    <div className="flex items-start gap-3">
                      <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 flex-shrink-0">
                        <i className="ri-mail-line text-primary-600"></i>
                      </div>
                      <div>
                        <div className="text-sm font-medium text-foreground-900">电子邮箱</div>
                        <div className="text-sm text-foreground-600">heimanime@163.com</div>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 flex-shrink-0">
                        <i className="ri-phone-line text-primary-600"></i>
                      </div>
                      <div>
                        <div className="text-sm font-medium text-foreground-900">联系电话</div>
                        <div className="text-sm text-foreground-600">010-8888-6666</div>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 flex-shrink-0">
                        <i className="ri-map-pin-line text-primary-600"></i>
                      </div>
                      <div>
                        <div className="text-sm font-medium text-foreground-900">办公地址</div>
                        <div className="text-sm text-foreground-600">北京市朝阳区动漫产业园A座12层</div>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 flex-shrink-0">
                        <i className="ri-time-line text-primary-600"></i>
                      </div>
                      <div>
                        <div className="text-sm font-medium text-foreground-900">工作时间</div>
                        <div className="text-sm text-foreground-600">周一至周五 9:00 - 18:00</div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Contact Form */}
                <div>
                  <h3 className="text-lg font-heading font-bold text-foreground-900 mb-5">在线留言</h3>
                  <form
                    data-readdy-form="d9qsennnahb7382oveqg"
                    onSubmit={async (e) => {
                      e.preventDefault();
                      const form = e.currentTarget;
                      const honeypot = (form.querySelector('[name="phone_alt"]') as HTMLInputElement)?.value?.trim();
                      if (honeypot) {
                        (form.querySelector('.contact-success') as HTMLElement)!.style.display = 'block';
                        (form.querySelector('.contact-form-fields') as HTMLElement)!.style.display = 'none';
                        return;
                      }
                      const formData = new FormData(form);
                      try {
                        const res = await fetch('https://readdy.ai/api/form/d9qsennnahb7382oveqg', {
                          method: 'POST',
                          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                          body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
                        });
                        const text = await res.text();
                        let parsed;
                        try { parsed = JSON.parse(text); } catch { parsed = null; }
                        if (res.ok && parsed?.code === 'OK') {
                          (form.querySelector('.contact-success') as HTMLElement)!.style.display = 'block';
                          (form.querySelector('.contact-form-fields') as HTMLElement)!.style.display = 'none';
                        } else {
                          const msg = parsed?.meta?.message || parsed?.message || '提交失败，请稍后再试';
                          const errEl = form.querySelector('.contact-error') as HTMLElement;
                          errEl!.textContent = msg;
                          errEl!.style.display = 'block';
                        }
                      } catch {
                        const errEl = form.querySelector('.contact-error') as HTMLElement;
                        errEl!.textContent = '网络错误，请检查连接后重试';
                        errEl!.style.display = 'block';
                      }
                    }}
                  >
                    <div className="contact-form-fields space-y-3">
                      <div className="grid grid-cols-2 gap-3">
                        <input
                          type="text"
                          name="name"
                          required
                          placeholder="你的名字"
                          className="w-full px-4 py-2.5 text-sm rounded-lg border border-background-200 bg-background-50 text-foreground-900 placeholder-foreground-400 focus:border-primary-300 focus:ring-1 focus:ring-primary-200 outline-none transition-colors"
                        />
                        <input
                          type="email"
                          name="email"
                          required
                          placeholder="你的邮箱"
                          className="w-full px-4 py-2.5 text-sm rounded-lg border border-background-200 bg-background-50 text-foreground-900 placeholder-foreground-400 focus:border-primary-300 focus:ring-1 focus:ring-primary-200 outline-none transition-colors"
                        />
                      </div>
                      <input
                        type="text"
                        name="subject"
                        placeholder="主题（选填）"
                        className="w-full px-4 py-2.5 text-sm rounded-lg border border-background-200 bg-background-50 text-foreground-900 placeholder-foreground-400 focus:border-primary-300 focus:ring-1 focus:ring-primary-200 outline-none transition-colors"
                      />
                      <textarea
                        name="message"
                        required
                        rows={4}
                        maxLength={500}
                        placeholder="你的留言（最多500字）"
                        className="w-full px-4 py-2.5 text-sm rounded-lg border border-background-200 bg-background-50 text-foreground-900 placeholder-foreground-400 focus:border-primary-300 focus:ring-1 focus:ring-primary-200 outline-none transition-colors resize-none"
                      ></textarea>
                      <input
                        type="text"
                        name="phone_alt"
                        tabIndex={-1}
                        autoComplete="off"
                        aria-hidden="true"
                        readOnly
                        className="form-honeypot"
                      />
                      <button
                        type="submit"
                        className="w-full py-3 text-sm font-medium rounded-lg bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
                      >
                        发送留言
                      </button>
                      <p className="contact-error text-xs text-primary-600 mt-1 hidden"></p>
                    </div>
                    <div className="contact-success text-center py-6" style={{ display: 'none' }}>
                      <div className="w-14 h-14 mx-auto mb-3 flex items-center justify-center rounded-full bg-accent-100">
                        <i className="ri-check-line text-2xl text-accent-600"></i>
                      </div>
                      <p className="text-base font-heading font-bold text-foreground-900">留言发送成功！</p>
                      <p className="text-sm text-foreground-500 mt-1">感谢你的留言，我们会在24小时内回复</p>
                    </div>
                  </form>
                </div>
              </div>

              {/* Map */}
              <div className="mt-10 rounded-xl overflow-hidden">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3061.945382360628!2d116.4551!3d39.9215!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x35f052fe3f8113f7%3A0x1b8b8432a3a8e9f!2sChaoyang!5e0!3m2!1szh-CN!2scn!4v1690000000000"
                  width="100%"
                  height="350"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="黑料天天动漫办公地址"
                ></iframe>
              </div>
            </div>
          </div>
        </section>

        {/* FAQ */}
        <section className="py-12 md:py-16">
          <div className="container-custom">
            <div className="max-w-3xl mx-auto">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-2 text-center">
                常见问题
              </h2>
              <div className="mt-8 space-y-3">
                <details className="group bg-background-50 rounded-xl border border-background-200/70">
                  <summary className="flex items-center justify-between px-5 py-4 cursor-pointer text-foreground-900 font-medium text-sm">
                    黑料天天动漫的内容来源是什么？
                    <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform"></i>
                  </summary>
                  <div className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                    我们的内容来源于行业内部人士投稿、公开报道整理以及编辑团队的独家调查。所有内容均经过编辑团队审核，确保信息的真实性和可靠性。
                  </div>
                </details>
                <details className="group bg-background-50 rounded-xl border border-background-200/70">
                  <summary className="flex items-center justify-between px-5 py-4 cursor-pointer text-foreground-900 font-medium text-sm">
                    如何向黑料天天动漫投稿爆料？
                    <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform"></i>
                  </summary>
                  <div className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                    您可以通过本页面的"在线留言"表单提交爆料信息，也可以直接发送邮件至heimanime@163.com。我们承诺对所有爆料人信息严格保密。
                  </div>
                </details>
                <details className="group bg-background-50 rounded-xl border border-background-200/70">
                  <summary className="flex items-center justify-between px-5 py-4 cursor-pointer text-foreground-900 font-medium text-sm">
                    黑料天天动漫的文章是否收费？
                    <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform"></i>
                  </summary>
                  <div className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                    目前黑料天天动漫的所有内容均免费开放阅读。我们通过广告合作和品牌赞助维持运营，不会对读者收取任何费用。
                  </div>
                </details>
                <details className="group bg-background-50 rounded-xl border border-background-200/70">
                  <summary className="flex items-center justify-between px-5 py-4 cursor-pointer text-foreground-900 font-medium text-sm">
                    如何与黑料天天动漫进行广告合作？
                    <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform"></i>
                  </summary>
                  <div className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                    欢迎品牌方和广告主通过"在线留言"表单或发送邮件至heimanime@163.com咨询合作事宜。我们的商务团队会在24小时内回复。
                  </div>
                </details>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
      <ScrollToTop />
    </div>
  );
}